export const APP_CONSTANTS = {
   SUCCESS: 'SUCCESS',
   FAILURE: 'FAILURE',
   LOGIN: '/login',
   LANGUAGE_ENGLISH: 'en-US',
   COUNTRY_US: 'US',
   COUNTRY_CA: 'CA',
   LANGUAGE_EN_US: 'en-US',
   LANGUAGE_EN_CA: 'en-CA',
   LANGUAGE_FR_CA: 'fr-CA',
   recaptchaURL: 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit',
   recaptchaURLFR: 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit&hl=fr&lang=fr',
   siteKeyCaptchaLocal: '6LdgbbUUAAAAADONNVKQp3CrnGq_C7RsQsmwvB6l',
   siteKeyCaptchaDev: '6LepHhEbAAAAAAsA768jOqBcprDLQcFv69SjKMfV',
   siteKeyCaptchaStage: '6LciIREbAAAAAPjCp6ffyetWeTCVUcTyV0BDKMrm',
   siteKeyCaptchaProd: '6LdYMaMZAAAAACHitUIiFdK4DFr6ht-FDHEeLeGu',
   registerInCIAM: '/registerInCIAM',
   SYSTEM_ID_US: 'A4426',
   SYSTEM_ID_CA: 'A5376',
   SYSTEM_ID_SMART_US: 'A6058',
   ERROR_DISPLAY_LANG_FR: 'FR',
   ERROR_DISPLAY_LANG_EN: 'EN',
   // PAYMENTDUESERVNAME: 'PAYMENTDUE',
   // MAINTANANCESERVICENAME: 'CHECKMAINTAINANCEWINDOW',
   InterceptorSkipHeader: 'X-Skip-Interceptor',
   TOGGLE_YES: 'YES',
   TOGGLE_NO: 'NO',
   creditAppPath: '/staticpages?pageName=creditapp&agreementNumber=',
   newCreditApp: 'home/creditapp/start_credit_app',
   creditAppBusinessPath: '/staticpages?pageName=creditappBusiness&agreementNumber=',
};
